import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconLampV3: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill || '#262626';
  return (
    <Icon {...props}>
      <path
        d="M14.25 21H9.75C9.336 21 9 20.664 9 20.25C9 19.836 9.336 19.5 9.75 19.5H14.25C14.664 19.5 15 19.836 15 20.25C15 20.664 14.664 21 14.25 21Z"
        fill={fill}
      />
      <path
        d="M12 3.457C11.586 3.457 11.25 3.121 11.25 2.707V0.75C11.25 0.336 11.586 0 12 0C12.414 0 12.75 0.336 12.75 0.75V2.707C12.75 3.121 12.414 3.457 12 3.457Z"
        fill={fill}
      />
      <path
        d="M18.571 6.179C18.379 6.179 18.187 6.106 18.041 5.959C17.748 5.666 17.748 5.191 18.041 4.898L19.425 3.514C19.718 3.221 20.193 3.221 20.486 3.514C20.779 3.807 20.779 4.282 20.486 4.575L19.102 5.959C18.955 6.105 18.763 6.179 18.571 6.179Z"
        fill={fill}
      />
      <path
        d="M23.25 12.75H21.293C20.879 12.75 20.543 12.414 20.543 12C20.543 11.586 20.879 11.25 21.293 11.25H23.25C23.664 11.25 24 11.586 24 12C24 12.414 23.664 12.75 23.25 12.75Z"
        fill={fill}
      />
      <path
        d="M19.955 20.705C19.763 20.705 19.571 20.632 19.425 20.485L18.041 19.101C17.748 18.808 17.748 18.333 18.041 18.04C18.334 17.747 18.809 17.747 19.102 18.04L20.486 19.424C20.779 19.717 20.779 20.192 20.486 20.485C20.339 20.632 20.147 20.705 19.955 20.705Z"
        fill={fill}
      />
      <path
        d="M4.04498 20.705C3.85298 20.705 3.66098 20.632 3.51498 20.485C3.22198 20.192 3.22198 19.717 3.51498 19.424L4.89898 18.04C5.19198 17.747 5.66698 17.747 5.95998 18.04C6.25298 18.333 6.25298 18.808 5.95998 19.101L4.57598 20.485C4.42898 20.632 4.23698 20.705 4.04498 20.705Z"
        fill={fill}
      />
      <path
        d="M2.707 12.75H0.75C0.336 12.75 0 12.414 0 12C0 11.586 0.336 11.25 0.75 11.25H2.707C3.121 11.25 3.457 11.586 3.457 12C3.457 12.414 3.121 12.75 2.707 12.75Z"
        fill={fill}
      />
      <path
        d="M5.42898 6.179C5.23698 6.179 5.04498 6.106 4.89898 5.959L3.51498 4.575C3.22198 4.282 3.22198 3.807 3.51498 3.514C3.80798 3.221 4.28298 3.221 4.57598 3.514L5.95998 4.898C6.25298 5.191 6.25298 5.666 5.95998 5.959C5.81198 6.105 5.62098 6.179 5.42898 6.179Z"
        fill={fill}
      />
      <path
        d="M15.75 12.5C15.336 12.5 15 12.164 15 11.75C15 10.233 13.767 9 12.25 9C11.836 9 11.5 8.664 11.5 8.25C11.5 7.836 11.836 7.5 12.25 7.5C14.593 7.5 16.5 9.407 16.5 11.75C16.5 12.164 16.164 12.5 15.75 12.5Z"
        fill={fill}
      />
      <path
        d="M13.25 24H10.75C9.90702 24 9.00003 23.36 9.00003 21.956V20.192C9.00003 19.131 8.54802 18.157 7.79102 17.587C5.60602 15.942 4.59503 13.236 5.15202 10.525C5.69703 7.869 7.84602 5.712 10.499 5.157C12.608 4.714 14.767 5.227 16.413 6.565C18.057 7.901 19 9.882 19 12C19 14.158 18.025 16.161 16.325 17.498C15.483 18.16 15 19.082 15 20.027V22.25C15 23.215 14.215 24 13.25 24ZM11.986 6.502C11.594 6.502 11.199 6.543 10.804 6.625C8.72802 7.059 7.04702 8.747 6.62002 10.826C6.18102 12.963 6.97503 15.095 8.69203 16.388C9.82303 17.24 10.499 18.662 10.499 20.192V21.956C10.499 22.047 10.511 22.5 10.749 22.5H13.249C13.387 22.5 13.499 22.388 13.499 22.25V20.027C13.499 18.618 14.191 17.267 15.397 16.318C16.734 15.268 17.5 13.694 17.5 12C17.5 10.336 16.758 8.779 15.466 7.729C14.478 6.927 13.253 6.502 11.986 6.502Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconLampV3;
